import {Component, OnInit} from '@angular/core';
import {NotificationService} from '@services/notification.service';
import {DashboardKeyMetricsService} from '@services/dashboard-key-metrics.service';

interface NotificationListResponse {
    notificationItems: any[];
    totalRecords: number;
    unreadNotification: number;
    highPriorityNotication: number;
    actionRequiredNotification: number;
}

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrl: './notifications-list.component.scss'
})
export class NotificationsListComponent implements OnInit {
    public data: any[] = [];
    public name: string = '';
    totalRecords: number = 0;
    pageSize: number = 50;
    currentPage: number = 1;
    public loading = true;
    public userDetail: any;
    public notificationDetail: any | null = null;
    public displayNotification: boolean = false;
    // Counters for header badges
    unreadNotification: number = 0;
    highPriorityNotication: number = 0;
    actionRequiredNotification: number = 0;

    constructor(
        private notificationservice: NotificationService,
        private dashboardService: DashboardKeyMetricsService
    ) {}

    ngOnInit(): void {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.getNotificationList();
    }

    getNotificationList(name: string = '') {
        this.notificationservice
            .getNotificationList(
                this.userDetail.id,
                name,
                this.currentPage,
                this.pageSize
            )
            .subscribe((result: NotificationListResponse) => {
                this.totalRecords = result.totalRecords;
                this.data = result.notificationItems || [];
                this.unreadNotification = result.unreadNotification || 0;
                this.highPriorityNotication =
                    result.highPriorityNotication || 0;
                this.actionRequiredNotification =
                    result.actionRequiredNotification || 0;
                this.loading = false;
            });
    }
    onPageChange(event: any) {
        this.currentPage = event.page + 1;
        this.getNotificationList();
    }
    calculateTimeAgo(dateTime: string): string {
        const notificationDate = new Date(dateTime + 'Z');
        const now = new Date();
        const diffInMinutes = Math.floor(
            (now.getTime() - notificationDate.getTime()) / (1000 * 60)
        );

        if (diffInMinutes < 60) {
            return `${diffInMinutes} mins ago`;
        } else if (diffInMinutes < 1440) {
            const hours = Math.floor(diffInMinutes / 60);
            return `${hours} hours ago`;
        } else {
            const days = Math.floor(diffInMinutes / 1440);
            return `${days} days ago`;
        }
    }
    openNotification(item: any) {
        this.notificationDetail = item;
        this.displayNotification = true;

        if (!item.isRead) {
            this.dashboardService.resolveAlert(item.id).subscribe({
                next: () => {
                    item.isRead = true;
                    if (this.unreadNotification > 0) {
                        this.unreadNotification -= 1;
                    }
                },
                error: () => {}
            });
        }
    }

    trackById(_index: number, item: any) {
        return item.id;
    }

    getLocationLine(item: any): string {
        const parts = [
            item.farmName,
            item.farmHouseName,
            item.partitionName
        ].filter((p) => !!p);
        return parts.join(' — ');
    }
    closePopup() {
        this.displayNotification = false;
    }
}
